import {
  endsStyleElement,
  escapesCssScope,
  parseInertBody,
  repairCustomHtml,
} from "~/shared/libs/customHtmlRepair.ts";
import { hasUntransformedCloudinaryUrl } from "~/shared/libs/customHtmlUrls.ts";

/** Untranslated on purpose: editor-facing, rendered only outside production or with `?preview`, like `jsErrorMessage`. */

/** The selectors must mirror what `repairCustomHtml` strips, or a repair goes unreported. */
const repairPatterns = [
  {
    notice: "data-component was removed. It does nothing here.",
    selector: "[data-component]",
  },
  {
    notice: "Inline styling was removed. Use the CSS field.",
    selector: "[style]",
  },
  {
    notice: "A <script> was removed. Use the JavaScript field.",
    selector: "script",
  },
  { notice: "A <style> was removed. Use the CSS field.", selector: "style" },
];

/** Repair patterns match the parsed markup, which the repair destroys; the url rule matches the repaired markup, so a `<script src>` raises the script notice alone. */
function customHtmlNotices(html: string | null, css: string | null): string[] {
  const notices: string[] = [];

  if (html) {
    const parsed = parseInertBody(html);
    notices.push(
      ...repairPatterns
        .filter(({ selector }) => !!parsed.querySelector(selector))
        .map(({ notice }) => notice),
    );

    if (hasUntransformedCloudinaryUrl(repairCustomHtml(html) ?? "")) {
      notices.push("A Cloudinary image is missing q_auto,f_auto,w_ or h_.");
    }
  }

  if (endsStyleElement(css)) {
    notices.push("A </style> was removed from the CSS.");
  }

  if (escapesCssScope(css)) {
    notices.push("A } that closes no rule was removed from the CSS.");
  }

  return notices;
}

export { customHtmlNotices };
